// @flow

import React, { Fragment } from 'react'
import styled, { css } from 'styled-components'
import Icon from 'components/atoms/Icon'
import HeaderStatus from 'components/atoms/HeaderStatus'
import Button from 'components/atoms/Button'
import SMConst from 'frontend_core/dist/constants/sm-const'
import ReservationModel from 'frontend_core/dist/model/Reservation'
import { fontSize, spacing } from 'frontend_core/dist/styles/variables'
import Colors from 'components/styles/colors'

const StatusGuide = styled.pre`
  margin-top: ${spacing.small_3}px;
  font-size: ${fontSize.small_3}px;
  text-align: center;
  line-height: 1.454;
  white-space: pre-wrap;
`
const ButtonWrapper = styled.div`
  margin-top: ${spacing.medium}px;
`

type PropTypes = {
  phaseText: string,
  isTypeStay?: boolean,
  isActiveReservation?: boolean,
  directReservation: boolean,
  reservationStatus: number,
  reservationStatusType: ?string,
  onClickChangeInquiryToReservation: Function,
  onClickSelectPayment: Function,
  onClickRecreateReservation: Function,
}

export default (props: PropTypes) => {
  const text = {
    reservationStatus: reservationStatus => {
      const statusText = {
        // 予約リクエスト
        [SMConst.ReservationStatus.Requested]: i18n.t(
          'page.dashboard.inbox.acceptRequest',
        ),
        // お問い合わせ
        [SMConst.ReservationStatus.Sent]: i18n.t(
          'page.dashboard.inbox.inquiryGuide',
        ),
        // 予約完了
        [SMConst.ReservationStatus.Confirmed]: i18n.t(
          'page.shared.reservation_completion',
        ),
        // 期限切れ
        [SMConst.ReservationStatus.Expired]:
          props.method === SMConst.ReservationMethod.Reservation
            ? i18n.t('page.dashboard.reservation.expiredReservationGuide')
            : i18n.t('page.dashboard.inbox.expiredGuide'),
        // 否認
        [SMConst.ReservationStatus.Rejected]: i18n.t(
          'page.dashboard.inbox.denialGuide',
        ),
        // ホストキャンセル
        [SMConst.ReservationStatus.OwnerCancelled]: i18n.t(
          'page.dashboard.inbox.hostCancelGuide',
        ),
        // ゲストキャンセル:払い戻しあり
        [SMConst.ReservationStatus.CancelSent]: i18n.t(
          'page.dashboard.inbox.guestCancelGuide',
        ),
        // ゲストキャンセル: 承認前
        [SMConst.ReservationStatus.Cancelled]: i18n.t(
          'page.dashboard.reservation.guestCancelBeforeAccept',
        ),
        // 運営キャンセル
        [SMConst.ReservationStatus.SystemCancelled]: i18n.t(
          'page.dashboard.inbox.systemCancelGuide',
        ),
      }
      return statusText[reservationStatus]
    },
  }

  return (
    <Fragment>
      <HeaderStatus
        phaseText={props.phaseText}
        isTypeStay={props.isTypeStay}
        isActiveReservation={props.isActiveReservation}
        full
        large
      />
      {props.directReservation && (
        <StatusGuide>
          <Icon
            className="fa fa-bolt"
            positionType="left"
            color={Colors.yellow}
            iconSize={11}
          />
          {i18n.t('page.dashboard.inbox.directReservation')}
        </StatusGuide>
      )}
      <StatusGuide>
        {text.reservationStatus(props.reservationStatus)}
      </StatusGuide>
      {/* お問い合わせのときだけ表示 */}
      {props.reservationStatusType === 'hasSentInquiry' && (
        <ButtonWrapper>
          <Button
            tag="anchor"
            colorType="blue"
            buttonType="medium"
            fullWidthSp
            onClick={props.onClickChangeInquiryToReservation}
          >
            {i18n.t('page.dashboard.reservation.changeRequestReservation')}
          </Button>
        </ButtonWrapper>
      )}
      {/* 期限切れのときだけ表示 */}
      {props.reservationStatusType === 'hasExpired' && (
        <ButtonWrapper>
          <Button
            tag="anchor"
            colorType="blue"
            buttonType="medium"
            fullWidthSp
            onClick={props.onClickRecreateReservation}
          >
            {props.method === SMConst.ReservationMethod.Reservation
              ? i18n.t('page.dashboard.reservation.requestReservationAgain')
              : i18n.t('page.dashboard.reservation.inquiryRequest.title')}
          </Button>
        </ButtonWrapper>
      )}
    </Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/components/molecules/ReservationStatusBlock/index.jsx